export default "__VITE_ASSET__B71aSw1m__"